export default {
    colors: {
        primary: '#F0767E',
        secondary: '#000000'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.primary,
        navItemTransform: 'uppercase',
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/bnp10Theme.js